/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { child_extras_ChildExtraResponse } from '../models/child_extras_ChildExtraResponse';
import type { child_extras_ChildExtrasListResponse } from '../models/child_extras_ChildExtrasListResponse';
import type { child_extras_CreateChildExtraRequest } from '../models/child_extras_CreateChildExtraRequest';
import type { child_extras_UpdateChildExtraRequest } from '../models/child_extras_UpdateChildExtraRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChildExtrasService {
    /**
     * Create a child extra
     * Creates an ad-hoc charge/credit for a child. The billing engine picks it up on the monthly invoice for the period containing serviceDate. Staff-only.
     * @param childId Child ID
     * @param body Extra to create
     * @returns child_extras_ChildExtraResponse Created
     * @throws ApiError
     */
    public static postApiV1ChildrenExtras(
        childId: string,
        body: child_extras_CreateChildExtraRequest,
    ): CancelablePromise<child_extras_ChildExtraResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/children/{childId}/extras',
            path: {
                'childId': childId,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a debtor's child extras
     * Returns the extras for every child billed via this debtor (debtor -> contract_payers -> contracts -> child). Paginated. Staff-only.
     * @param debtorId Debtor account ID
     * @param limit Page size (1-100, default 50)
     * @param offset Offset (default 0)
     * @returns child_extras_ChildExtrasListResponse OK
     * @throws ApiError
     */
    public static getApiV1DebtorAccountsExtras(
        debtorId: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<child_extras_ChildExtrasListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/debtor-accounts/{debtorId}/extras',
            path: {
                'debtorId': debtorId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete a child extra
     * Soft-deletes an unbilled child extra. Returns 409 if the extra has already been billed. Staff-only.
     * @param id Child extra ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Extras(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/extras/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a child extra (partial)
     * Updates an unbilled child extra. Returns 409 if the extra has already been billed (stamped onto a finalized invoice). Staff-only.
     * @param id Child extra ID
     * @param body Fields to update
     * @returns child_extras_ChildExtraResponse OK
     * @throws ApiError
     */
    public static patchApiV1Extras(
        id: string,
        body: child_extras_UpdateChildExtraRequest,
    ): CancelablePromise<child_extras_ChildExtraResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/extras/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
}
